import {
  BenchmarkType,
  CalendarReportType,
  IBenchmarkExpandStatus,
  MarketType
} from '@mg-platform/reports/reports-data-access'
import { ICompareWithSelection } from '../../interfaces/compare-with.interface'
import { IRangeDateInfo, ITableAction, ITableSortInfo } from '@mg-platform/core/core-feature'
import { ISelectItem } from '@mg-platform/core/core-ui'
import { IOrganizationUser } from '@mg-platform/users/users-data-access'
import { CountryCode } from '../../enums/country-code.enum'
import { GoalChartType } from 'dashboard-data-access'

export interface FiltersStateModel {
  shopId: string
  groupId: string
  compareWith: ICompareWithSelection
  marketType: MarketType
  weekNumber: number
  calendarReportType?: CalendarReportType
  calendarViewDate?: number
  benchmarkType: BenchmarkType
  benchmarkStartDate: number
  benchmarkEndDate: number
  benchmarkSecondCompareWith: ICompareWithSelection
  benchmarkThirdCompareWith: ICompareWithSelection
  benchmarkCustomDateInfo: IRangeDateInfo
  benchmarkExpandStatus: IBenchmarkExpandStatus
  compTrendAvgSalesPerBay: boolean | string
  compTrendAvgCarCount: boolean | string
  compTrendAvgTicket: boolean | string
  adminOrganizationsFilters: ITableAction
  adminNotificationsFilters: ITableAction
  adminMarketPricingFilters: ITableAction
  adminShopsFilters: ITableAction
  adminUnimportedShopsFilters: ITableAction
  adminGroupsFilters: ITableAction
  adminUsersFilters: ITableAction
  adminShopCalendarViewDate: Date
  salesTrackerDateInfo: IRangeDateInfo
  grossprofitDateInfo: IRangeDateInfo
  laborsDateInfo: IRangeDateInfo
  laborsSortInfo: ITableSortInfo
  laborsShowMobileBanner: boolean
  adminExcludeBatch: boolean
  rankingsDateInfo: IRangeDateInfo
  rankingsSelectedGroupId: string
  rankingsSelectedShopId: string
  salesByCategoryDateInfo: IRangeDateInfo
  salesByCategorySortInfo: ITableSortInfo
  allCountries: ISelectItem[]
  usersTableSortInfo: ITableSortInfo
  myGroupsTableSortInfo: ITableSortInfo
  myShopsTableSortInfo: ITableSortInfo
  userDetialsShops: string[]
  userDetialsInfo: IOrganizationUser
  apiTestingList: string[]
  adminMarketPricingsByStateSortInfo: ITableSortInfo
  adminMarketPricingsByStateCountry: CountryCode
  adminMarketPricingsByStateExcludeBatch: boolean
  compSalesSelectedCompare: string
  dashboardSelectedTrendType: string
  dashboardSelectedViewType: string
  dashboardSelectedCountryType: string
  goalChartType: GoalChartType
}

export type FilterStateKeys = keyof FiltersStateModel
